const DashboardHistoryList = () => {
  return (
    <>
      <p className="text-size">
        Product with category kids added &nbsp; <i className="fa-solid fa-check text-size"></i>
      </p>
    </>
  );
};

export default DashboardHistoryList;
